import React from 'react';
import {Form} from "@redriver/cinnamon";

const NonPropagatingInput = (props) => {
    return (
        <Form.Input {...props} onKeyDown={(e) => e.stopPropagation()}/>
    )
}

export default NonPropagatingInput;
